import { useLimitedCountList, useCreate } from 'storfox-api-hooks'
import useAllSearchParams from 'storfox-route-hooks/src/useAllSearchParams'

import { queryToParams } from '~/utils'
import * as API from '~/constants/api'

import { SaleOrderFilterSerializer } from '../../serializers/SaleOrder'

export const useSaleOrderList = () => {
  const { select, ...searchParams } = useAllSearchParams()
  const params = queryToParams(SaleOrderFilterSerializer, searchParams, 'guid')

  const { getList, ...state } = useLimitedCountList(API.SALE_ORDER_LIST, { ...params })
  return { ...state, getList: () => getList(params) }
}

export const useSaleOrderReportGenerate = () => {
  const { create, ...state } = useCreate(API.ORDER_REPORT_GENERATE)
  return { ...state, generate: create }
}
